import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { UserLeaveBalanceSummary } from '../interfaces/leave.interface';

export const LeaveBalanceService = {
    getMyBalance: async (): Promise<UserLeaveBalanceSummary> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.LEAVE_BALANCE.MY_BALANCE(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    getAllUserBalances: async (): Promise<UserLeaveBalanceSummary[]> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.LEAVE_BALANCE.ALL_USER_BALANCES(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    }
};
